<template>
  <div class="d-flex flex-wrap align-center">
    <div
      :style="{
        'width': datePickerWidth
      }"
    >
      <Datepicker
        :solo="solo"
        :filled="filled"
        :label="label"
        v-model="localValue"
        :prependIcon="datePickerPrependIcon"
        :appendIcon="datePickerAppendIcon"
      ></Datepicker>
    </div>
    <TimePicker
      :label="null"
      v-model="time"
    ></TimePicker>
  </div>
</template>

<script>
import Datepicker from '../datepicker'
import TimePicker from '../../native/timePicker'

import emittable from '../../mixins/emittable'

export default {
  name: "DateTimePicker",
  mixins: [emittable],
  components: {
    Datepicker, 
    TimePicker
  },
  data: function() {
    let time;
    if(this.value) {
      time = ('0' + (this.value.getHours())).slice(-2) + ':' + ('0' + (this.value.getMinutes())).slice(-2)
    }

    return {
      // should always be a date
      localValue: this.value,
      // should always be a string with 'hh:mm'
      time: time
    }
  },
  props: {
    value: {
      type: Date,
      default: function() {
        new Date()
      }
    },
    solo: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Date'
    },
    datePickerWidth: {
      type: String,
      default: "150px"
    },
    datePickerPrependIcon: {
      type: String,
      default: undefined
    },
    datePickerAppendIcon: {
      type: String,
      default: undefined
    }
  },
  methods: {
    dateEqual(date1, date2) {
      if((date1 && !date2) || (date2 && !date1)) return false
      if(!date1 && !date2) return true

      let equal = true
      if(date1.getMonth() != date2.getMonth()) equal = false
      if(date1.getDate() != date2.getDate()) equal = false
      if(date1.getFullYear() != date2.getFullYear()) equal = false
      if(date1.getHours() != date2.getHours()) equal = false
      if(date1.getMinutes() != date2.getMinutes()) equal = false
      return equal
    }
  },
  watch: {
    localValue(newVal) {
      if(!newVal) {
        this.emit('input', undefined)
      } else if(!this.dateEqual(this.localValue, this.value)) {
        this.emit('input', this.localValue)
      }
    },
    time(newVal) {
      if(!newVal) return
      let hours = parseInt(newVal.split(':')[0])
      this.localValue.setHours(hours)
      let minutes = parseInt(newVal.split(':')[1])
      this.localValue.setMinutes(minutes)

      if(!this.dateEqual(this.localValue, this.value)) {
        this.emit('input', this.localValue)
      }
    },
    value(newVal) {
      this.localValue = newVal
      
      if(newVal) {
        this.time = ('0' + (this.value.getHours())).slice(-2) + ':' + ('0' + (this.value.getMinutes())).slice(-2)
      } else {
        this.time = ""
      }
    }
  }
}
</script>

<style>

</style>